import React, { Component } from 'react'
import { observer } from 'mobx-react'
import * as R from 'ramda'
import { reaction } from 'mobx'
import Button from '../../../UniformComponents/Button'
import Accordion from '../../ReportV2/components/Accordion'
import Checkbox from '../../form/Checkbox'
import WidgetContainer from '../WidgetContainer'
import ChartPreviewSettings from './ChartPreviewSettings'
import chartIcons from './chartIcons'
import Panel from '../../../UniformComponents/Panel'

const sizes = [
    {
        name: 'Small',
        divs: 4,
        size: 2,
    },
    {
        name: 'Medium',
        divs: 2,
        size: 4,
    },
    {
        name: 'Large',
        divs: 1,
        size: 8,
    },
]

const chartGroups = {
    'Column charts': ['column', 'stackedColumn'],
    'Bar charts': ['bar', 'stackedBar'],
    'Line charts': ['line'],
    'Pie charts': ['pie', 'donut'],
    'Text charts': ['text', 'multiText'],
    'Other charts': ['treemap', 'gauge', 'radar', 'lmx'],
    'Quadrant Analysis': ['quadrantAnalysis'],
}

@observer
class ChartPreviewContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            error: {
                chart: false,
            },
            openAccordian: 'chart',
            data: false,
            accordianHeight: 0,
            collapseRight: true,
        }
        const { dashboardWizardStore } = props
        const { newWidget, widgetType } = dashboardWizardStore
        if (newWidget.chart) {
            this.getDashboardData()
        } else {
            const allowedCharts = this.getAllowedCharts()
            let defaultChart
            Object.values(chartGroups).some((chartGroup) => {
                const charts = chartGroup.filter((c) => allowedCharts.includes(c))
                if (charts.length) {
                    [defaultChart] = charts
                    return true
                }
                return false
            })
            this.changeChart(defaultChart)
        }

        reaction(
            () => [
                newWidget.question,
                newWidget.respondentType,
                newWidget.productType,
                newWidget.surveyType,
                newWidget.industry,
                newWidget.timePeriod,
                newWidget.dataLevel,
                newWidget.displayAs,
                newWidget.nonQuestionKpiType,
                newWidget.nonQuestionType],
            async () => {
                if (newWidget.question
                    && newWidget.respondentType
                    && newWidget.productType
                    && newWidget.surveyType
                    && newWidget.industry
                    && newWidget.timePeriod
                    && newWidget.dataLevel
                    && newWidget.displayAs
                    && widgetType === 'single'
                ) {
                    const allowedCharts = this.getAllowedCharts()
                    let defaultChart
                    Object.values(chartGroups).some((chartGroup) => {
                        const charts = chartGroup.filter((c) => allowedCharts.includes(c))
                        if (charts.length) {
                            [defaultChart] = charts
                            return true
                        }
                        return false
                    })
                    this.changeChart(defaultChart, false)
                    const newData = await this.getDashboardData()
                    this.updatePreview(newData)
                } else if (newWidget.nonQuestionKpiType
                    && newWidget.nonQuestionType
                    && newWidget.respondentType
                    && newWidget.productType
                    && newWidget.surveyType
                    && newWidget.industry
                    && newWidget.timePeriod
                    && newWidget.dataLevel
                    && widgetType === 'aggregated') {
                    const allowedCharts = this.getAllowedCharts()
                    let defaultChart
                    Object.values(chartGroups).some((chartGroup) => {
                        const charts = chartGroup.filter((c) => allowedCharts.includes(c))
                        if (charts.length) {
                            [defaultChart] = charts
                            return true
                        }
                        return false
                    })
                    this.changeChart(defaultChart, false)
                    const newData = await this.getDashboardData()
                    this.updatePreview(newData)
                } else {
                    this.setState({ data: false })
                }
            },
        )

        reaction(
            () => [newWidget.multiQuestion],
            async () => {
                if (widgetType === 'multi' && newWidget.multiQuestion.every((q) => !!q.question)
                ) {
                    const allowedCharts = this.getAllowedCharts()
                    let defaultChart
                    Object.values(chartGroups).some((chartGroup) => {
                        const charts = chartGroup.filter((c) => allowedCharts.includes(c))
                        if (charts.length) {
                            [defaultChart] = charts
                            return true
                        }
                        return false
                    })
                    this.changeChart(defaultChart, false)
                    const newData = await this.getDashboardData()
                    this.updatePreview(newData)
                } else {
                    this.setState({ data: false })
                }
            },
        )

        reaction(
            () => [newWidget.quadrant],
            async () => {
                if (widgetType === 'quadrantAnalysis' && [newWidget.quadrant.xAxis, newWidget.quadrant.yAxis].every((q) => !!q.value)
                ) {
                    const allowedCharts = this.getAllowedCharts()
                    let defaultChart
                    Object.values(chartGroups).some((chartGroup) => {
                        const charts = chartGroup.filter((c) => allowedCharts.includes(c))
                        if (charts.length) {
                            [defaultChart] = charts
                            return true
                        }
                        return false
                    })
                    this.changeChart(defaultChart, false)
                    const newData = await this.getDashboardData()
                    this.updatePreview(newData)
                } else {
                    this.setState({ data: false })
                }
            },
        )

        // reaction(
        //     () => [newWidget.timePeriod,
        //         newWidget.dataLevel,
        //         newWidget.displayAs,
        //         newWidget.question,
        //         newWidget.respondentType,
        //         newWidget.productType,
        //         newWidget.surveyType,
        //         newWidget.industry],
        //     async () => {
        //         if (
        //             newWidget.timePeriod
        //             && newWidget.dataLevel
        //             && newWidget.displayAs
        //             && newWidget.question
        //             && newWidget.respondentType
        //             && newWidget.productType
        //             && newWidget.surveyType
        //             && newWidget.industry
        //         ) {
        //             const newData = await this.getDashboardData()
        //             this.updatePreview(newData)
        //         } else {
        //             this.setState({ data: false })
        //         }
        //     },
        // )
    }

    componentDidMount() {
        this.resizeHandler()
        window.addEventListener('resize', this.resizeHandler)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeHandler)
    }

    getAllowedCharts = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, dashStore } = dashboardWizardStore
        const { getChartScope, oId } = dashStore
        const dataLevel = (newWidget.dataLevel === 'product' ? 'event' : newWidget.dataLevel) === getChartScope(oId) ? 'currentLevel' : 'levelBelow'

        let allowedCharts

        if (!['KPI', 'multiQuestion'].includes(newWidget.nonQuestionType) && newWidget.displayAs === 'nps') {
            allowedCharts = R.pathOr(
                [],
                [newWidget.questionTypeCode, newWidget.displayAs, dataLevel],
                dashboardWizardStore.questionChartOptions,
            )
        } else {
            const chartPath = ['KPI', 'multiQuestion'].includes(newWidget.nonQuestionType)
                ? [newWidget.nonQuestionKpiType === 'LMX' ? 'LMX' : newWidget.nonQuestionType, dataLevel]
                : [newWidget.questionTypeCode, newWidget.isNumeric, dataLevel]

            allowedCharts = ['KPI', 'multiQuestion'].includes(newWidget.nonQuestionType)
                ? R.pathOr([], chartPath, dashboardWizardStore.questionChartOptions)
                : R.pathOr(
                    R.pathOr([], chartPath, dashboardWizardStore.questionChartOptions),
                    [...chartPath, newWidget.displayAs],
                    dashboardWizardStore.questionChartOptions,
                )
        }

        if (newWidget.nonQuestionType === 'quadrantAnalysis') allowedCharts.push('quadrantAnalysis')
        return Array.isArray(allowedCharts) ? allowedCharts : []
    }

    changeChart = async (chart, updatePreview = true) => {
        const { dashboardWizardStore } = this.props
        const { setChart, newWidget, changeNewWidget } = dashboardWizardStore
        const { error } = this.state
        const chartIcon = chartIcons.find((c) => c.key === chart)

        if (chart !== newWidget.chart) {
            const defaultRenderSettings = R.pathOr({
                format: newWidget.displayAs === 'pct' ? '%' : undefined,
            }, ['kpiRenderSettings'], newWidget)
            setChart(chart, chartIcon.defaultSize)
            changeNewWidget(defaultRenderSettings, 'widgetRenderSettings')
            if (updatePreview) this.updatePreview()
        }
        this.setState({ error: { ...error, chart: false } })
    }

    renderChart = (chart) => {
        const { dashboardWizardStore } = this.props
        const { newWidget } = dashboardWizardStore
        const chartIcon = chartIcons.find((c) => c.key === chart)

        return (
            <div
                className={`chartContainer ${chart === newWidget.chart ? 'active' : ''}`}
                onClick={() => this.changeChart(chart)}
            >
                <div className="chartButton chart">
                    {chartIcon.chart}
                </div>
            </div>
        )
    }

    renderCharts = () => {
        const allowedCharts = this.getAllowedCharts()
        return Object.keys(chartGroups).map((g) => {
            const charts = chartGroups[g].filter((c) => allowedCharts.includes(c))
            if (!charts.length) return null
            return (
                <div>
                    <div className="chartGroupHeading">{g}</div>
                    <div className="chartButtons">
                        {charts.map((c) => (
                            this.renderChart(c)
                        ))}
                    </div>
                </div>
            )
        })
    }

    updatePreview = async (newData) => {
        const { dashboardWizardStore } = this.props
        const { newWidget } = dashboardWizardStore
        const data = newData || this.state.data
        this.setState(
            {
                data:
                {
                    ...data,
                    chartType: newWidget.chart,
                    widgetRenderSettings: newWidget.widgetRenderSettings,
                },
            },
        )
    }

    getDashboardData = async () => {
        const { dashboardWizardStore } = this.props
        const { dashStore } = dashboardWizardStore
        const { getChartData } = dashStore
        const widget = dashboardWizardStore.addWidget(true)
        const chartData = await getChartData([widget])
        this.setState({ data: chartData[0] })
        return chartData[0]
    }

    resizeHandler = () => {
        const bodyHeight = this.bodyEl.clientHeight
        // 176 is padding (20) plus 3 accordian closed heights (52 * 3)
        this.setState({ accordianHeight: bodyHeight - 176 })
    }

    renderSizes = ({ name, divs, size }) => {
        const { dashboardWizardStore } = this.props
        const { setChartSize, newWidget } = dashboardWizardStore
        const arrDivs = []
        for (let i = 0; i < divs; i += 1) {
            arrDivs.push(<div className="sizeDiv" />)
        }
        return (
            <div
                className={`sizeContainer  ${size === newWidget.defaultSize ? 'active' : ''}`}
                onClick={() => {
                    if (size !== newWidget.defaultSize) setChartSize(size)
                }}
            >
                <div className="illustration">
                    {arrDivs}
                </div>
                <div className="description">
                    <div className="name">{name}</div>
                    <div className="input">
                        <Checkbox
                            onBlur={() => {
                                if (size !== newWidget.defaultSize) setChartSize(size)
                            }}
                            checked={size === newWidget.defaultSize}
                        />
                    </div>
                </div>
            </div>
        )
    }

    renderChartSizes = () => sizes.map((size) => this.renderSizes(size))

    addWidget = () => {
        const { dashboardWizardStore } = this.props
        const { newWidget, addWidget } = dashboardWizardStore
        const { error } = this.state
        if (!newWidget.chart) {
            this.setState({ error: { ...error, chart: true } })
            return
        }
        addWidget()
    }

    changeTitle = ({ value }) => {
        const { dashboardWizardStore } = this.props
        const { changeNewWidget } = dashboardWizardStore
        changeNewWidget(value, 'widgetTitle')
    }

    render() {
        const { dashboardWizardStore } = this.props
        const {
            getDefaultTitle, dashStore, newWidget,
        } = dashboardWizardStore
        const { chart, questionId } = newWidget
        const {
            openAccordian, error, data, accordianHeight, collapseRight,
        } = this.state
        return (
            <>
                <Panel cssClass="chartAdvancedPreview">
                    <div className="body advancedPreviewBody" ref={(el) => { this.bodyEl = el }}>
                        <div className="previewPane">
                            <WidgetContainer
                                renderChart
                                chart={dashStore.getChart({
                                    ...data,
                                    title: getDefaultTitle(),
                                    containerSize: { height: 400, width: 450 },
                                    optionFilter: newWidget.optionFilter,
                                    filter: newWidget.filter,
                                }, data.data)}
                                chartKey={chart}
                                title={getDefaultTitle()}
                                DynamicDashboardStore={dashStore}
                                preview
                                changeTitle={this.changeTitle}
                                key={questionId}
                            />
                        </div>
                    </div>
                </Panel>
                <Panel cssClass={`chartSettings ${collapseRight ? 'collapsed' : ''}`}>
                    <div
                        className="collapseIcon left"
                        onClick={() => this.setState({ collapseRight: !collapseRight })}
                    >
                        <div
                            className="collapseIconContainer"
                        >
                            {
                                collapseRight
                                    ? <i className="fa-regular fa-chevron-left" />
                                    : <i className="fa-regular fa-chevron-right" />
                            }
                        </div>
                    </div>
                    <div className="collapsedMenuLabel" style={{ display: collapseRight ? 'block' : 'none' }}>
                        Chart settings
                    </div>
                    <div className="body advancedPreviewBody chartSettingsBody" ref={(el) => { this.bodyEl = el }}>
                        <div className="optionsPane accordian">
                            <div className="accordian">
                                <Accordion
                                    height={accordianHeight}
                                    style={{ overflow: 'auto' }}
                                    cssClass="chartAccordian"
                                    title={(
                                        <div className="title">
                                            Widget type
                                            <i
                                                className="fa-regular fa-circle-exclamation"
                                                style={
                                                    {
                                                        color: 'red',
                                                        background: 'none',
                                                        marginLeft: '20px',
                                                        display: error.chart ? 'block' : 'none',
                                                    }
                                                }
                                            />
                                        </div>
                                    )}
                                    openIcon="fa-regular fa-chevron-up"
                                    closeIcon="fa-regular fa-chevron-down"
                                    isOpen={openAccordian === 'chart'}
                                    defaultOpen
                                    toggleOpen={() => {
                                        this.setState({ openAccordian: openAccordian === 'chart' ? '' : 'chart' })
                                    }}
                                >
                                    <div className="accordianBody">
                                        {this.renderCharts()}
                                    </div>
                                    <div className="buttonContainer" style={{ display: 'flex', justifyContent: 'end' }}>
                                        <Button
                                            cssClass="primary regular"
                                            style={{ marginBottom: '5px', padding: '0 35px' }}
                                            onClick={() => this.setState({ openAccordian: 'options' })}
                                        >
                                            Next
                                        </Button>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="accordian">
                                <Accordion
                                    height={accordianHeight}
                                    style={{ overflow: 'auto' }}
                                    cssClass="chartAccordian"
                                    title={(
                                        <div className="title">
                                            Settings
                                            <i
                                                className="fa-regular fa-circle-exclamation"
                                                style={
                                                    {
                                                        color: 'red',
                                                        background: 'none',
                                                        marginLeft: '20px',
                                                        display: error.chart ? 'block' : 'none',
                                                    }
                                                }
                                            />
                                        </div>
                                    )}
                                    openIcon="fa-regular fa-chevron-up"
                                    closeIcon="fa-regular fa-chevron-down"
                                    isOpen={openAccordian === 'options'}
                                    toggleOpen={() => {
                                        this.setState({ openAccordian: openAccordian === 'options' ? '' : 'options' })
                                    }}
                                >
                                    <div className="accordianBody">
                                        <ChartPreviewSettings
                                            dashboardWizardStore={dashboardWizardStore}
                                            updatePreview={this.updatePreview}
                                            widgetWithData={data}
                                        />
                                        <Button
                                            cssClass="primary regular"
                                            style={{ float: 'right', marginTop: '20px', padding: '0 35px' }}
                                            onClick={() => this.setState({ openAccordian: 'sizes' })}
                                        >
                                            Next
                                        </Button>
                                    </div>
                                </Accordion>
                            </div>
                            <div className="accordian widgetSize">
                                <Accordion
                                    height={accordianHeight}
                                    style={{ overflow: 'auto' }}
                                    cssClass="chartAccordian"
                                    title={(
                                        <div className="title">
                                            Sizes
                                            <i
                                                className="fa-regular fa-circle-exclamation"
                                                style={
                                                    {
                                                        color: 'red',
                                                        background: 'none',
                                                        marginLeft: '20px',
                                                        display: error.chart ? 'block' : 'none',
                                                    }
                                                }
                                            />
                                        </div>
                                    )}
                                    openIcon="fa-regular fa-chevron-up"
                                    closeIcon="fa-regular fa-chevron-down"
                                    isOpen={openAccordian === 'sizes'}
                                    toggleOpen={() => {
                                        this.setState({ openAccordian: openAccordian === 'sizes' ? '' : 'sizes' })
                                    }}
                                >
                                    <div className="accordianBody chartSizes">
                                        {this.renderChartSizes()}
                                    </div>
                                </Accordion>
                            </div>
                        </div>
                    </div>
                </Panel>
            </>
        )
    }
}

export default ChartPreviewContainer
